import { DOCUMENT } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppSettings } from './enums/app-settings.enum';
import { AccountService } from './services/account.service';
import { AdobeAnalyticsService } from './services/adobe-analytics.service';
import { LanguageSwitchService } from './services/language-switch.service';
import { UrlService } from './services/url.service';
import { ProductService } from './services/product.service';
import { UtilitiesService } from './utilities/utilities.service';
import { ApplicationInitializationService } from './services/application-initialization.service';
import { filter } from 'rxjs/operators';
import { SubjectService } from './services/subject.service';

// import * as $ from "jquery";
declare let ga: any;
declare let window: any;
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  title = 'addons';
  loaderColor: string = AppSettings.LOADER_COLOR;
  URLS: any;
  currentUrl: string = null;
  accountList: any;
  userAccounts: any;
  loadAPI: Promise<any>;

  constructor(
    private UTS: UtilitiesService,
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private R: Renderer2,
    private aRoute: ActivatedRoute,
    private AS: AccountService,
    private AAS: AdobeAnalyticsService,
    private urlService: UrlService,
    private productService: ProductService,
    private changeDetectionRef: ChangeDetectorRef,
    private applicationInitializationService: ApplicationInitializationService,
    private router: Router,
    private SS: SubjectService
  ) {
    this.UTS.log('BUILD 0.0.52 19-02-2025 ADDONS BUILD');
    this.route.queryParamMap.subscribe((params) => {
      this.aRoute.queryParams.subscribe((q) => {
        if (q && q?.env) {
          if (q.env == 'mobile') {
            localStorage.clear();
            if (q && q['access-token']) {
              this.UTS.setAccessToken(q['access-token']);
            }
            if (q && q['magentoCartId']) {
              this.UTS.setMagentoCartId(q['magentoCartId']);
            }
            if (q && q['access_token']) {
              this.UTS.setWSO2AccessToken(q['access_token']);
            }
            if (q && q['JSESSIONID']) {
              this.UTS.setJSessionID(q['JSESSIONID']);
            }
            //bigIpServer
            if (q && q['bigIpServer']) {
              this.UTS.setBigIpServer(q['bigIpServer']);
            }
            if (q && q['subscription']) {
              this.UTS.setSubscription(q['subscription']);
            }
            if (q && q['source']) {
              this.UTS.setNavigationSourceFromApp(q['source']);
            }
            if (q && q['individualLoginAccountNo']) {
              this.UTS.setIndividualLoginAccountNo(q['individualLoginAccountNo']);
            }
          }
        }
      });
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = parentLanguage
        ? parentLanguage.toLocaleLowerCase()
        : 'english';
      localStorage.removeItem('language');
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
        ? token.params.lang.toLowerCase()
        : localLanguage
        ? localLanguage.toLocaleLowerCase()
        : 'en';

      if (lang === 'ar' || parentLang === 'arabic') {
        this.LSS.setLanguage('ar');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`ar${AppSettings?.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`ar${AppSettings?.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings?.APPLICATION_NAVIATION_URL}`);
      } else {
        this.LSS.setLanguage('en');
        this.LSS.changeLanguage();
        this.UTS.setAHURL(`en${AppSettings?.APPLICATION_HEADER_URL}`);
        this.UTS.setAFURL(`en${AppSettings?.APPLICATION_FOOTER_URL}`);
        this.UTS.setANURL(`ar${AppSettings?.APPLICATION_NAVIATION_URL}`);
      }
    });
    this.SS.routingService.subscribe((url)=>{
      if(url)
      this.router.navigateByUrl(url);
    })
  }

  ngOnInit() {
    this.changeDetectionRef.detectChanges();
    this.loadAddonScript(
      this.applicationInitializationService?.environmentConfig?.ADOBE_SCRIPT
    );

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.urlService.setPreviousUrl(this.currentUrl);
        this.currentUrl = event.url;
        this.AAS.pageLoadedEvent(this.currentUrl, document.title, false, null);
      });
  }
  ngAfterViewInit() {
    // this.UTS.getHeaders();
    setTimeout(() => {
      this.setPageOritentation(this.LSS.getLanguage());
    }, 500);
    this.getHeaderCSSLibs(AppSettings.HEADER_LIBS);
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  public getHeaderURL() {
    return this.UTS.getAHURL();
  }

  public getFooterURL() {
    return this.UTS.getAFURL();
  }
  public getNavigationURL() {
    return this.UTS.getANURL();
  }

  setPageOritentation(lang) {
    if (lang == 'ar') {
      this.R.setAttribute(document.documentElement, 'lang', 'ar');
      this.R.setAttribute(document.body, 'dir', 'rtl');
    } else {
      this.R.setAttribute(document.documentElement, 'lang', 'en');
      this.R.setAttribute(document.body, 'dir', 'ltr');
    }
  }

  getHeaderCSSLibs(headerUrl) {
    this.productService.getLibs('/' + headerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          const scriptRegex =
            /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          const filteredHtml = res.htmlSrc.replace(scriptRegex, '');
          document
            .getElementsByTagName('head')[0]
            .insertAdjacentHTML('beforeend', filteredHtml);
        }
      },
      (e) => {
        console.log('failed to retrive header libs');
      }
    );
  }

  getHeaderLibs(headerUrl) {
    this.productService.getLibs('/' + headerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(
            res.htmlSrc,
            document.getElementById('headerLibs'),
            'header'
          );
        }
      },
      (e) => {
        console.log('failed to retrive header libs');
      }
    );
  }
  getFooterLibs(footerUrl) {
    this.productService.getCMSContent('/' + footerUrl, 'GET').subscribe(
      (res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(
            res.htmlSrc,
            document.getElementById('footerLibs'),
            'footer'
          );
        }
      },
      (e) => {
        console.log('failed to retrive footer libs');
      }
    );
  }
  loadScripts(htmlStr: string, targetEl: any, type: string) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');
    for (let index = 0; index < html?.scripts.length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      scriptTag.async = true; // makes script run asynchronously
      this.R.appendChild(targetEl, scriptTag);
    }
  }
  loadAddonScript(src: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      document.getElementsByTagName('body')[0].appendChild(script);
      resolve('');
    });
  }
}
